import { ThemeProvider, Typography, createTheme, TypographyProps } from "@mui/material";
import createPalette from "@mui/material/styles/createPalette";
import { Variant } from "@mui/material/styles/createTypography";
import React from "react";
import { vars } from "../Variables";

const { secondaryFont, textColor, secondaryTextColor, primaryFont } = vars;

declare module '@mui/material/styles' {
  interface Theme { }
  // allow configuration using `createTheme`
  interface ThemeOptions { }
}

const customPalette = createPalette({
  primary: {
    main: textColor
  },
  secondary: {
    main: secondaryTextColor
  }
})

const theme = createTheme({
  typography: {
    // fontFamily: secondaryFont,

    allVariants: {
      lineHeight: '140%',
    },

    h1: {
      color: customPalette.primary.main,
      fontWeight: 700,
      fontSize: 24,
      lineHeight: '130%',
    },

    h2: {
      color: customPalette.primary.main,
      fontWeight: 700,
      fontSize: 20,
    },

    h3: {
      color: customPalette.primary.main,
      fontWeight: 700,
      fontSize: 16,
    },

    h4: {
      color: customPalette.primary.main,
      fontWeight: 500,
      fontSize: 14,
    },

    h5: {
      color: customPalette.primary.main,
      fontWeight: 500,
      fontSize: 10,
    },

    h6: {
      color: customPalette.primary.main,
      fontWeight: 300,
      fontSize: 10,
    },

    body1: {
      color: customPalette.primary.main,
      fontWeight: 400,
      fontSize: 16,
    },

    body2: {
      color: customPalette.secondary.main,
      fontWeight: 500,
      fontSize: 16,
    }
  }
});


export interface IText extends TypographyProps {
  children: React.ReactNode;
  variant?: Variant;
  textTransform?: any;
  isPrimaryFont?: boolean;
  [x: string]: any;
}

export const Text: React.FC<IText> = (props) => {
  const { children, variant, textTransform, isPrimaryFont = false, ...rest } = props;
  return (
    <ThemeProvider theme={theme}>
      <Typography
        fontFamily={isPrimaryFont ? primaryFont : secondaryFont}
        textTransform={textTransform}
        variant={variant}
        {...rest}
      >
        {children}
      </Typography>
    </ThemeProvider>
  );
};